const defaultStatus = { label: 'Not Requested', className: 'badge-danger' };

const PayoutStatus = ({ status }) => {
  const statusMap = {
    approved: { label: 'Approved', className: 'badge-success' },
    pending: { label: 'Requested', className: 'badge-warning' },
    rejected: { label: 'Rejected', className: 'badge-danger' },
  };

  const { label, className } = statusMap[status] || defaultStatus;

  return (
    <span className={`badge ${className}`}>
      {label}
    </span>
  );
};

export default PayoutStatus;
